var _module = require('../module');
var $ = require('jquery');

_module.directive('googleSearchAutocomplete', [
    '$log',
    '$timeout',

    function googleSearchAutocomplete($log, $timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function googleSearchAutocompleteLink($scope, elem, attrs, ngModelCtrl) {
                var defaultOpts = {
                    type: '(regions)',
                    componentRestrictions: { country: 'us' }
                };
                var options = attrs.googleSearchAutocomplete ? $scope.$eval(attrs.googleSearchAutocomplete) : defaultOpts;
                var autocomplete = new google.maps.places.Autocomplete(elem[0], options);

                /*
                This is stupid but its the only way to fix
                the autocomplete for ios mobile and home screen app.
                */
                if(window.innerWidth <= 1024) {
                    var delay = 30;

                    if ('standalone' in navigator && navigator.standalone && (/iphone|ipod|ipad/gi).test(navigator.platform) && !(/Safari/i).test(navigator.appVersion)) {
                        delay = 380;
                    }

                    $log.debug('delay', delay);

                    $(document).on({
                        'DOMNodeInserted': function() {
                            $log.debug('Mobile Device Fix');

                            $('.pac-item, .pac-item span', this).addClass('needsclick');
                            $('.pac-item', this).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();

                                setTimeout(function () {
                                    elem.blur();
                                }, delay);
                            });
                        }
                    }, '.pac-container');
                }
                /*
                End Stupid mobile code
                */

                // Listeners
                google.maps.event.addListener(autocomplete, 'place_changed', placeChanged);
                elem.on('keydown', onKeypress);

                // Functions
                function placeChanged() {
                    var place = autocomplete.getPlace();

                    $log.debug('Place', place);
                    $log.debug('ngModelCtrl', ngModelCtrl);

                    if(ngModelCtrl && place.formatted_address) {
                        ngModelCtrl.$setViewValue(place.formatted_address.replace(/, (usa|united states)/gi, ''));
                        ngModelCtrl.$render();
                    }
                }

                function onKeypress(e) {
                    if(e.code === 'Enter' || (e.originalEvent && e.originalEvent.code === 'Enter')) {
                        e.preventDefault();

                        if(attrs.hasOwnProperty('submitOnEnter')) {
                            $timeout(function () {
                                var btn = $(elem).closest('form').find('[type="submit"]');

                                if(btn) btn.trigger('click');
                            }, 200);
                        }
                    }
                }
            }
        };
    }
]);
